import { Tab, TabProps } from '@mui/material';
import Box from '@mui/material/Box';
import { cloneElement } from 'react';

type TabWithErrorProps = TabProps & {
    label: string;
    value: string;
    icon?: React.ReactElement;
    iconPosition?: 'top' | 'bottom' | 'start' | 'end';
    hasError?: boolean;
    incomplete?: boolean;
};

const TabWithError = ({ label, value, icon, hasError, incomplete, ...props }: TabWithErrorProps) => {
    // A red dot flags an invalid value; an amber dot flags a section that is still
    // incomplete (required-to-enable fields not yet filled). An error wins over incomplete.
    const dotColor = hasError ? 'error.main' : incomplete ? 'warning.main' : undefined;
    return (
        <Tab
            value={value}
            {...props}
            icon={icon ? cloneElement(icon) : undefined}
            label={
                <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                    {label}
                    {dotColor && (
                        <Box
                            sx={{
                                width: 6,
                                height: 6,
                                borderRadius: '50%',
                                backgroundColor: dotColor,
                            }}
                        />
                    )}
                </Box>
            }
        />
    );
};

export default TabWithError;